import { useState } from 'react';
import { t } from '@lingui/macro';
import { IconButton, MenuBody, MenuHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
import { AccountInfoSection } from './AccountInfoSection';
import { CompanySelector } from './CompanySelector';
import { LanguageSelector } from './LanguageSelector';
import { UserCard } from '../UserCard';
import { StyledMenu } from './styled';
export function UserAccountMenu() {
    const [open, setOpen] = useState(false);
    const isMobile = useMobile();
    const toggle = () => setOpen(!open);
    return (<StyledMenu open={open} onClose={toggle} options={{
            placement: isMobile ? 'bottom-start' : 'left-start',
        }} target={<UserCard isActive={open} onClick={toggle}/>}>
      <MenuHeader action={<IconButton $round appearance="ghost" size="small" onClick={toggle}>
            <Falcon icon="close"/>
          </IconButton>} title={t({
            message: 'User account',
            comment: 'User menu: header text',
        })}/>
      <MenuBody>
        <AccountInfoSection />
        <CompanySelector />
        <LanguageSelector />
      </MenuBody>
    </StyledMenu>);
}
